<template>
    <div v-if="discountTypes" class="discount">
        <div class="d-flex align-items-center" v-if="showDiscount">
            <label>Discount</label>

            <div class="d-flex ml-auto align-items-center">
                <input ref="discountInput" class="glued-right" type="text" v-model="form.billing.discountValue" @keyup="validateDiscount">

                <vSelect class="glued-left"
                    v-model="selectedDiscountType"
                    :options="discountTypes"
                    :searchable="false"
                    label="symbol"
                    @input="updateDiscountType"></vSelect>
            </div>
        </div>
        <div class="bold" v-else>
            <div @click="openDiscount">
                <i class="ico-add color-1 add-circle border-color-1"></i>
                Add discount
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        mixins: [reservationsMixin],
        props: {
            reservation: Object,
            product: Object,
        },
        data: function() {
            return {
                form: {},
                showDiscount: false,
                selectedDiscountType: null,
            }
        },
        asyncComputed: {
            async discountTypes() {
                try {
                    let response = await axios.get('/api/settings/GetValueTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Replace description with symbols

                        response.data.forEach(d => {
                            if (d.description === 'Percentage') {
                                this.$set(d, 'symbol', '%');
                            }
                            else {
                                this.$set(d, 'symbol', '€');
                            }
                        });

                        // Validate array

                        if (this.form.billing === undefined || !this.form.billing) {
                            this.$set(this.form, 'billing', {
                                discountType: null,
                                discountValue: 0,
                            });
                        }

                        // Map FK information through selects

                        if (this.form.billing.discountType) {
                            this.selectedDiscountType = response.data.find(item => item.id === this.form.billing.discountType);
                            this.openDiscount();
                            this.validateDiscount();
                        }
                        else {
                            this.selectedDiscountType = response.data[0];
                            this.form.billing.discountType = response.data[0].id;
                            this.form.billing.discountValue = 0;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
        },
        methods: {
            openDiscount: function() {
                this.showDiscount = !this.showDiscount;

                this.$nextTick(function() {
                    this.$refs.discountInput.focus();
                });
            },
            updateDiscountType: function() {
                this.form.billing.discountType = this.selectedDiscountType.id;
                this.validateDiscount();
            },
            validateDiscount: function() {
                let value = this.form.billing.discountValue;
                let type = this.selectedDiscountType;

                // If none of the boundary conditions are met, this is an invalid discount
                // so we must reset things

                if ((type.description === 'Currency' && value > 0 && value <= this.finalPriceWithoutTaxes) ||
                    (type.description === 'Percentage' && value > 0 && value <= 100)) {
                }
                else {
                    this.form.billing.discountValue = 0;
                }

                this.$emit('updateDiscountType', this.form.billing.discountType);
                this.$emit('updateDiscountValue', this.form.billing.discountValue);
            },
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>



// WEBPACK FOOTER //
// Discount.vue?5ad14334